﻿import {ResponseApi} from "../../Model/ResponseApi.js";
import {IProjetModel} from "../../Model/Projet/ProjetModel.js";
import {JsonFetchJson} from "../../Helper/FetchHelper.js";
import {IProjetFilterModel} from "../../Model/FilterModel/ProjetFilterModel.js";


export class Projet {
        public static Read = async (filter: IProjetFilterModel) => {
            return JsonFetchJson.Post<ResponseApi<Array<IProjetModel>>>("/projet", filter)
                .then(response => {
                    return response.Data;
                });
         }
    }
